import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'stepsContainer', 'product']

  connect() {
    this.product = false
  }
}
